import React from "react";
import "./navbar.css";

export const NavBar = () => {
  return (
    <>
      <nav className='navbar navbar-expand-lg bg-dark bg-opacity-10'>
        <div className='container-fluid'>
          <button
            className='navbar-toggler'
            type='button'
            data-bs-toggle='collapse'
            data-bs-target='#navbarNav'
            aria-controls='navbarNav'
            aria-expanded='false'
            aria-label='Toggle navigation'>
            <span className='navbar-toggler-icon'></span>
          </button>
          <div className='collapse navbar-collapse' id='navbarNav'>
            <ul className='navbar-nav'>
              <li className='nav-item'>
                <a className='nav-link' href='/cyri'>
                  Can You RUN It
                </a>
              </li>
              <li className='nav-item mx-0 px-0'>
                <a className='nav-link' href='/game-lists'>
                  Game Lists
                </a>
              </li>
              <li className='nav-item'>
                <a className='nav-link' href='/my-computer-details'>
                  My Computer Details
                </a>
              </li>
              <li className='nav-item'>
                <a className='nav-link' href='/rank-my-computer'>
                  Rate My PC
                </a>
              </li>
              <li className='nav-item'>
                <a className='nav-link' href='/gaming-pc'>
                  What Will RUN It
                </a>
              </li>

              <li className='nav-item'>
                <a className='nav-link' href='/gpu-compare'>
                  GPU Compare
                </a>
              </li>

              <li className='nav-item'>
                <a className='nav-link active' aria-current='page' href='#'>
                  Speed Test
                </a>
              </li>

              {/* <li className='nav-item'>
                <a className='nav-link' href='https://www.systemrequirementslab.com/driver-updates'>
                  Driver Updates
                </a>
              </li> */}
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};
